import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "inviteStep1View__content"
}
const _hoisted_2 = { class: "inviteStep1View__formBlock" }
const _hoisted_3 = { class: "inviteStep1View__formBlock" }
const _hoisted_4 = {
  key: 1,
  class: "inviteStep2View__content"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "inviteStep2View__tip" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon_success" }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "邀请链接已保存"),
    /*#__PURE__*/_createElementVNode("p", null, "请将链接发送给您的员工")
  ])
], -1)
const _hoisted_6 = { class: "inviteStep2View__methods" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "方式一", -1)
const _hoisted_8 = { class: "content methodOne" }
const _hoisted_9 = { class: "left_content" }
const _hoisted_10 = { class: "text-primary" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "点击链接：", -1)
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", null, "方式二", -1)
const _hoisted_14 = { class: "content" }
const _hoisted_15 = { class: "text" }
const _hoisted_16 = { class: "text-primary" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "attach" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_app_enterprise_input = _resolveComponent("app-enterprise-input")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_input_number = _resolveComponent("input-number")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_app_section = _resolveComponent("app-section")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_app_qr_code = _resolveComponent("app-qr-code")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer inviteStep1View__wrap" }, {
    title: _withCtx(() => [
      _createVNode(_component_router_link, {
        class: "link-goback",
        to: _ctx.$route.query.goback || { name: 'main.staff.list' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_app_icon, { type: "arrow-left" })
        ]),
        _: 1
      }, 8, ["to"]),
      _createTextVNode(" 批量邀请员工 ")
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_steps, {
        class: "inviteStep1View__steps",
        current: _ctx.current
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_step, { title: "填写邀请信息" }),
          _createVNode(_component_a_step, { title: "发送邀请" })
        ]),
        _: 1
      }, 8, ["current"]),
      (_ctx.current === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_a_form, {
              ref: "editorFormRef",
              class: "inviteStep1View__form",
              model: _ctx.formData,
              rules: _ctx.rules,
              "label-col": _ctx.labelCol,
              "wrapper-col": _ctx.wrapperCol
            }, {
              default: _withCtx(() => [
                _createVNode(_component_app_section, { title: "邀请信息" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_a_form_item, {
                        label: "邀请名称",
                        required: "",
                        name: "invitationName"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.formData.invitationName,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.invitationName) = $event)),
                            maxlength: 10,
                            "allow-clear": "",
                            placeholder: "邀请名称"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "企业审核",
                        required: "",
                        name: "examineState"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio_group, {
                            value: _ctx.formData.examineState,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.examineState) = $event)),
                            options: _ctx.validateOptions
                          }, null, 8, ["value", "options"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "公司",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_app_enterprise_input, {
                            value: _ctx.formData.enterpriseId,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.enterpriseId) = $event)),
                            style: {"width":"100%"},
                            "disable-in-open": ""
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "部门" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tree_select, {
                            value: _ctx.formData.departmentIds,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.departmentIds) = $event)),
                            style: {"width":"100%"},
                            "allow-clear": "",
                            multiple: "",
                            "show-line": true,
                            placeholder: "请选择部门",
                            "tree-data": _ctx.departmentTree,
                            "tree-node-filter-prop": "title",
                            "dropdown-style": { maxHeight: '300px' },
                            "search-placeholder": "请选择"
                          }, null, 8, ["value", "tree-data"])
                        ]),
                        _: 1
                      }),
                      (!_ctx.isScheduleModel)
                        ? (_openBlock(), _createBlock(_component_a_form_item, {
                            key: 0,
                            label: "绑定车辆"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                value: _ctx.formData.vehicleId,
                                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.vehicleId) = $event)),
                                style: {"width":"100%"},
                                mode: "multiple",
                                placeholder: "请选择车辆",
                                "option-filter-prop": "label",
                                options: _ctx.autoList
                              }, null, 8, ["value", "options"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_form_item, { label: "预分配额度" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_input_number, {
                            value: _ctx.formData.preDistributionAmount,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.preDistributionAmount) = $event)),
                            style: {"width":"100%"},
                            placeholder: "请输入预分配额度"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "邀请失效时间" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_date_picker, {
                            value: _ctx.formData.lastValidTime,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.lastValidTime) = $event)),
                            style: {"width":"100%"},
                            "value-format": "YYYY-MM-DD HH:mm:ss",
                            "show-time": "",
                            placeholder: "请选择日期时间"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "最大邀请人数" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_input_number, {
                            value: _ctx.formData.maxInvitees,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.maxInvitees) = $event)),
                            precision: 0,
                            style: {"width":"100%"},
                            placeholder: "请输入最大邀请人数"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "加油制度",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: _ctx.formData.restrictConfNo,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.restrictConfNo) = $event)),
                            style: {"width":"100%"},
                            placeholder: "请选择用户制度",
                            options: _ctx.localSceneList
                          }, null, 8, ["value", "options"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_a_form_item, { "wrapper-col": { span: 14, offset: 8 } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _ctx.onSubmit
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("提交")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["model", "rules", "label-col", "wrapper-col"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.current === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", null, [
                    _createTextVNode("邀请您加入 "),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.detail.enterpriseName), 1),
                    _createTextVNode(" 使用能链企业版，享受加油企业支付")
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_11,
                    _createElementVNode("a", {
                      class: "link",
                      target: "_blank",
                      href: _ctx.detail.url
                    }, _toDisplayString(_ctx.detail.url), 9, _hoisted_12)
                  ])
                ]),
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.onCopyUrl
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("复制链接文字")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.detail.enterpriseName), 1),
                  _hoisted_17,
                  _createTextVNode(" 邀请您使用能链企业版，享受加油企业支付 ")
                ]),
                _createElementVNode("p", _hoisted_18, [
                  _createVNode(_component_app_qr_code, {
                    ref: "QrCodeRef",
                    class: "qrcode",
                    value: _ctx.detail.url,
                    size: 56,
                    level: "M"
                  }, null, 8, ["value"])
                ]),
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.onDownloadQrcode
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("下载二维码")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}